import {util} from '@/utils/utils'
import {getGridData} from './form-render'
/**
 * 加载我的审批记录
 * @param params
 */
export const getMyCommentData = () => {
  let params = {formKey: 'sys-wf-comment', id: 'sys-wf-comment-1', pageIndex: 1, pageSize: 20}
  return getGridData(params)
}

/**
 * 删除流程实例
 * @param params
 * @returns {Promise<any>}
 */
export const deleteData = (params) => { // 删除表单
  util.mask('正在删除')
  var p = new Promise(function (resolve, reject) {
    util.restDelete('/api_v1/wf/proc_insts', params, function (res) {
      if (res != undefined && res != null) {
        if (res.status == 200) {
          resolve(res.data)
        } else {
          util.warn('删除失败' + res.errorMsg)
        }
      }
      util.unmask()
    })
  })
  return p
}

/**
 * 获取流转记录,流程示例id和业务数据主键必须至少一个有值
 * @param params
 */
 export const getWorkflowTask = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restGet('/api_v1/wf/tasks', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject()
      }
    })
  })
  return p
}

/**
 * 获取流转记录,流程示例id和业务数据主键必须至少一个有值
 * @param params
 */
export const getWorkflowCount = (params) => {
  var p = new Promise(function (resolve, reject) {
    util.restGet('/api_v1/wf/tasks/count', params, res => {
      if (res.status === 200) {
        resolve(res.data)
      }else{
        reject()
      }
    })
  })
  return p
}



// WEBPACK FOOTER //
// ./src/api/workflow.js